import React from 'react';

// Catches render-time errors anywhere below it so a single thrown component
// doesn't white-screen the whole app.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught error:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign('/');
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 16,
        background: 'var(--bg)', color: 'var(--text)', padding: 24, textAlign: 'center',
      }}>
        <img src="/yt8.png" alt="Your Top 8" style={{ width: 64, height: 64, objectFit: 'contain', opacity: 0.8 }} />
        <h1 style={{ fontSize: 22, fontWeight: 800, margin: 0 }}>Something went wrong</h1>
        <p style={{ color: 'var(--muted)', margin: 0, maxWidth: 360, fontSize: 14, lineHeight: 1.6 }}>
          The page hit an unexpected error. Reloading usually fixes it.
        </p>
        <button className="btn btn-primary" onClick={this.handleReload} style={{ marginTop: 4 }}>
          Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
